import Select from '../Select/Select';

// Ð¡ÑÑÑÑÐ¸Ðº Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ°ÑÐºÑÑÑÐ¾Ð¼ ÑÐ¿Ð¸ÑÐºÐµ: Ð² ÑÐ°Ð¼Ð¾Ð¼ Ð¿Ð¾Ð»Ðµ Ð¸ Ð² ÑÑÑÐ¾ÐºÐµ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÑ
// ÑÐ¸Ð»ÑÑÑÐ¾Ð² Ð¾Ð½ Ð±Ñ ÑÑÑÐ°ÑÐµÐ²Ð°Ð» Ð¿Ð¾ÑÐ»Ðµ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ»ÐµÐ´ÑÑÑÐµÐ³Ð¾ Ð²ÑÐ±Ð¾ÑÐ°.
const formatOptionLabel = (option, meta) =>
  meta?.context === 'menu' && option?.count != null ? `${option.label} (${option.count})` : option?.label;

/**
 * Ð¡ÐµÐ»ÐµÐºÑ ÑÐ¸Ð»ÑÑÑÐ° ÑÑÐ¾ÐºÐ°. ÐÐ°ÑÐ¸Ð°Ð½ÑÑ Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð³Ð¾ÑÐ¾Ð²ÑÐ¼Ð¸ Ñ Ð±ÑÐºÐ° Ð²Ð¼ÐµÑÑÐµ Ñ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾Ð¼ Ð¼Ð°ÑÐ¸Ð½
 * (getStockFilters), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð·Ð´ÐµÑÑ Ð½ÐµÑ Ð½Ð¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°, Ð½Ð¸ Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐµÐ¹ Ð¼ÐµÐ¶Ð´Ñ
 * Ð¿Ð¾Ð»ÑÐ¼Ð¸: Ð²ÑÐ±ÑÐ°Ð»Ð¸ Ð³Ð¾ÑÐ¾Ð´ â Ð±ÑÐº ÑÐ°Ð¼ Ð²ÐµÑÐ½ÑÐ» ÑÐ¾Ð»ÑÐºÐ¾ ÐµÐ³Ð¾ ÐÐ¦.
 */
const SelectFacet = ({ options = [], handleSetSelect, handleSetState, ...props }) => (
  <Select
    handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
    handleSetState={handleSetState}
    options={options}
    formatOptionLabel={formatOptionLabel}
    isSearchable
    isClearable
    {...props}
  />
);

export default SelectFacet;
